import React from 'react';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const AuditFilterControls = ({ filters, onFilterChange, onExport }) => {
  const handleActionTypeChange = (e) => {
    onFilterChange({ actionType: e?.target?.value });
  };

  const handleResourceTypeChange = (e) => {
    onFilterChange({ resourceType: e?.target?.value });
  };

  const handleDateRangeChange = (field, value) => {
    onFilterChange({
      dateRange: {
        ...filters?.dateRange,
        [field]: value
      }
    });
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 sm:p-6 space-y-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} strokeWidth={2} />
          Filters
        </h3>
        <button
          onClick={onExport}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors text-sm font-medium"
        >
          <Icon name="Download" size={16} strokeWidth={2} />
          Export CSV
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Action Type Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Action Type
          </label>
          <select
            value={filters?.actionType}
            onChange={handleActionTypeChange}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
          >
            <option value="all">All Actions</option>
            <option value="CREATE">Create</option>
            <option value="UPDATE">Update</option>
            <option value="DELETE">Delete</option>
            <option value="VIEW">View</option>
            <option value="EXPORT">Export</option>
          </select>
        </div>

        {/* Resource Type Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Resource Type
          </label>
          <select
            value={filters?.resourceType}
            onChange={handleResourceTypeChange}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
          >
            <option value="all">All Resources</option>
            <option value="SYMPTOM_ENTRY">Symptom Entry</option>
            <option value="MANAGED_PROFILE">Managed Profile</option>
            <option value="USER_PROFILE">User Profile</option>
            <option value="CAREGIVER_ALERT">Caregiver Alert</option>
          </select>
        </div>

        {/* Start Date Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Start Date
          </label>
          <input
            type="date"
            value={filters?.dateRange?.start}
            onChange={(e) => handleDateRangeChange('start', e?.target?.value)}
            max={filters?.dateRange?.end}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
          />
        </div>

        {/* End Date Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            End Date
          </label>
          <input
            type="date"
            value={filters?.dateRange?.end}
            onChange={(e) => handleDateRangeChange('end', e?.target?.value)}
            min={filters?.dateRange?.start}
            max={format(new Date(), 'yyyy-MM-dd')}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
          />
        </div>
      </div>
    </div>
  );
};

export default AuditFilterControls;